import { render, staticRenderFns } from "./SingleRoute.vue?vue&type=template&id=11282ec4&scoped=true&"
import script from "./SingleRoute.vue?vue&type=script&lang=js&"
export * from "./SingleRoute.vue?vue&type=script&lang=js&"
import style0 from "./SingleRoute.css?vue&type=style&index=0&id=11282ec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11282ec4",
  null
  
)

export default component.exports